var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOrderSummaryView = function SvgOrderSummaryView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "order-summary-view_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#order-summary-view_svg__a)",
    "data-name": "Scroll Group 82",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.866 13.917a1.1 1.1 0 0 1-.785-.331L3.437 7.835a1.137 1.137 0 0 1 0-1.591 1.1 1.1 0 0 1 1.568 0l4.856 4.95 4.856-4.95a1.1 1.1 0 0 1 1.568 0 1.137 1.137 0 0 1 0 1.591l-5.642 5.75a1.1 1.1 0 0 1-.777.332",
    "data-name": "Path 52"
  }))));
};
export default SvgOrderSummaryView;